










import { defineComponent } from "@vue/composition-api";
import { getMediaDuration } from "@/lib/time";

const DEFAULT_DURATION_VALUE = "0:00";

export default defineComponent({
  name: "BaseDuration",
  props: {
    value: { type: [String, Number], required: true },
    transparent: { type: Boolean, default: false },
    backgroundColor: { type: String },
  },
  computed: {
    duration(): string {
      if (typeof this.value === "number" && this.value >= 0) return getMediaDuration(this.value);
      if (typeof this.value === "string" && this.value && !isNaN(Number(this.value)) && Number(this.value) > 0) {
        return getMediaDuration(Number(this.value));
      }
      return DEFAULT_DURATION_VALUE;
    },
  },
});
